// extracted by mini-css-extract-plugin
export default {"tipHeader":"la0gd","column":"lTfTP","highlightBox":"gL_Lw"};